
<div *ngIf="result" class="results">
    <div class="section">
        <h1 class="title">Result</h1>
        <h2 class="subtitle">Your patient is <b>{{result.result}}</b></h2>
        <p class="copy">{{result.copy}}<b>{{result.riskScore}}</b></p>
        <p class="copy-disclaimer p2">*Risk score is based on the actual patients without EPI from the screening tool development cohort.</p>
        <div class="result-disclaimer">
            <img src="assets/icons/icon-info.svg" alt="">
            <p class="p2">This tool is not a diagnostic test for EPI, and is not designed to provide any treatment recommendations for patients.</p>
        </div>
    </div>
    <div class="summary">
        <h2 class="summary__title">Your decision tree reponses</h2>
        <p class="summary__copy">The result, that your patient is <b>{{result.result}}</b>, was based on analysis of your responses, detailed below:</p>
        <div class="summary__info">
            <div class="summary__list-subtitles">
                <h3 class="summary__subtitle question">Question</h3>
                <h3 class="summary__subtitle reponse">Response</h3>
            </div>
            <ol class="summary__list">
                <div *ngFor="let answer of result.chosenAnswers" class="summary__list-item">
                    <li></li>
                    <li class="summary__copy question">{{answer.question}}</li>
                    <p class="summary__copy response"><b>{{answer.answer}}</b></p>
                </div>
            </ol>
            <div class="p2 restart-copy">
                <p>If any of the responses above are inaccurate, please <a (click)="startOver('results-page-repeat-screening-tool-link')">repeat the EPI Screening Tool</a>, providing the correct responses.</p>
            </div>
        </div>
        <h3 class="summary__title2">Summary</h3>
        <ul class="copy-list">
            <li *ngFor="let summary of result.summary" [innerHTML]="summary"></li>
        </ul>
    </div>
    <div class="summary white-bg">
        <h2 class="summary__title">Suggested publications</h2>
        <ul class="copy-list">
            <li *ngFor="let publication of result.publications" [innerHTML]="publication"></li>
        </ul>
    </div>
    <div class="c-columns c-columns--results">
        <div class="column">
            <h5 class="column__title">Download result</h5>
            <p class="column__copy download">Download this page to retain this result for your records.</p>
            <a class="a-button" href="{{resultPdf}}" download (click)="trackDownload()">
                <app-button icon="assets/icons/icon-download.svg" text="Download summary"></app-button>
            </a>
        </div>
        <div class="column">
            <h5 class="column__title">Provide feedback</h5>
            <p class="column__copy">We would welcome your feedback, please let us know what you think about this tool.</p>
            <app-button icon="assets/icons/icon-arrow-forward.svg" text="Provide feedback" path="screening-tool-landing" tab="feedback" (btnClick)="track('results-page-provide-feedback')"></app-button>
        </div>
        <div class="column">
            <h5 class="column__title">Start another test</h5>
            <p class="column__copy">Start over and begin a new test.</p>
            <app-button icon="assets/icons/icon-leave.svg" text="Start another test" (btnClick)="startOver('results-page-start-another-test-button')"></app-button>
        </div>
    </div>
    <app-bottom-navigation 
        backRoute="screening-tool-landing" 
        backTab="introduction" 
        backText="Introducing the screening tool" 
        continueRoute="screening-tool-landing" 
        continueTab="feedback" 
        continueText="Feedback">
    </app-bottom-navigation>
    <app-references [references]="result.references"></app-references>
</div>
